import { fetchAndParse, jsonHeaders } from '#lib/helpers/fetch.js';
import { useAuthMutation } from '#lib/hooks/use-mutation.js';
import toast from 'react-hot-toast';

async function saveTasks(body, authHeaders) {
    return await fetchAndParse(`${API_URL}/p/tasks`, {
        method: 'PUT',
        headers: {
            ...jsonHeaders,
            ...authHeaders
        },
        body: JSON.stringify(body)
    });
}

export function useTasks(onClose, setTasks) {
    return useAuthMutation({
        mutationFn: saveTasks,
        onSuccess: (res) => {
            toast.success(_t.global.success());
            setTasks(res.model.tasks)
            onClose();
        },
        onError: () =>
            toast.error(_t.global.error())

    });
}